import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "placeholder"]

  pick(event) {
    event.preventDefault()
    this.inputTarget.click()
  }

  preview() {
    const file = this.inputTarget.files[0]
    if (!file) return

    this.previewTarget.src = URL.createObjectURL(file)
    this.previewTarget.classList.remove("d-none")
    if (this.hasPlaceholderTarget) this.placeholderTarget.classList.add("d-none")
  }
}
